<template>
  <div class="plain-text text-default padding--bottom-1" v-if="textData">
    <div class="row">
      <div class="col-12">
        <h3 v-if="textData.headline" v-text="textData.headline"/>
        <div v-if="textData.text.html" v-html="textData.text.html"/>
      </div>
    </div>
  </div>
</template>

<script>
import AppConst from '../config/app.const';
import Settings from '../config/settings';

export default {
  name: 'PlainText',
  props: {
    id: String
  },
  data () {
    return {
      textData: null
    };
  },
  methods: {
    async fetchModuleText () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=moduleText&id=${this.id}`,
        lifetime: Settings.LIFETIME_DEFAULT
      })
        .then(response => {
          this.textData = response.moduleText;
        });
    }
  },
  created () {
    this.fetchModuleText();
  }
};
</script>

<style lang="scss">
  .plain-text {
    h3 {
      margin-bottom: $gap * 2;
    }
    h4 {
      font-size: 18px;
      text-transform: none;
    }
    p {
      margin-bottom: $gap * 1.5;
    }
    li div p {
      margin: 0;
    }
  }
</style>
